import React, { useState, memo, useCallback } from 'react';
import PropTypes from 'prop-types';
export const AreasContext = React.createContext();

const AreasProvider = props => {
  const [state, setState] = useState({ areas: {} });

  const getElemByAreaKey = useCallback(
    key => {
      const result = state.areas[key];
      return result;
    },
    [state.areas]
  );

  const setElemByAreaKey = useCallback(
    (key, elem) => {
      if (!state.areas[key]) {
        setState(state => ({
          areas: { ...state.areas, [key]: elem }
        }));
      }
    },
    [state.areas]
  );

  return <AreasContext.Provider value={{ areas: state.areas, getElemByAreaKey, setElemByAreaKey }}>{props.children}</AreasContext.Provider>;
};

AreasProvider.propTypes = {
  children: PropTypes.node
};

export default memo(AreasProvider);
